/*
 * @Description: 甘特图
 * @Author: yy
 * @Date: 2019-08-20 10:56:27
 * @LastEditors: yy
 * @LastEditTime: 2020-08-24 10:50:28
 */

// import echarts from 'echarts'
import * as echarts from 'echarts'


function renderItem(params, api) {
  var categoryIndex = api.value(0);
  var start = api.coord([api.value(1), categoryIndex]);
  // console.log(categoryIndex);
  
  var end = api.coord([api.value(2), categoryIndex]);
  var height = 10 //api.size([0, 1])[1] * 0.6;
  const val = api.value(3)
  if (val === 0) return false

  
  var rectShape = echarts.graphic.clipRectByRect({
    x: start[0],
    y: start[1] - height / 2,
    width: end[0] - start[0],
    height: height
  }, {
    x: params.coordSys.x,
    y: params.coordSys.y,
    width: params.coordSys.width,
    height: params.coordSys.height
  });


  const result = rectShape && {
    type: 'rect',
    shape: rectShape,
    style: api.style(),
    styleEmphasis: api.styleEmphasis()
  };

  if (!rectShape) {
    debugger
    return {}
  }
  if (rectShape.width > 20) {
    result.style.text = val
  }
  result.style.textFill = 'rgba(0, 0, 0, 1)'
  // result.style.fontSize = 14
  result.style.fontSize = 10
  result.style.textStroke = null
  result.styleEmphasis.textFill = '#000'
  return result
}



export default (guttJson, name) => {
  const dateRangeText = guttJson.dateRangeText || '8月1日-8月31日'
  if (guttJson.list === undefined) {
    return {}
  }

  let max = 0
  let constList = []
  guttJson.list.forEach(item => {
    const value = item.value
    if (value[3] > max) {
      max = value[3]
    }
    if (constList[value[0]] === undefined) {
      constList[value[0]] = 0
    }
    constList[value[0]] += value[3]
  })
  let maxObj = {}
  if (max < 1000) {
    maxObj.max = max
  }
  
  return {
    title: {
      show: true,
      text: `${name || '鸿蒙'}全网热点TOPIC趋势图`,
      top: 0,
      left: 50,
      subtext: '数据来源：数榜舆图\n时间窗口：' + dateRangeText,
      subtextStyle: {
        lineHeight: 20
      }
    },
    tooltip: {
      show:false,
    },
    toolbox: {
      right: 20,
      feature: {
        saveAsImage: {
          pixelRatio: 2
        },
        myDownload: {
          show: false,
          title: '保存图表',
          icon: 'M4.7,22.9L29.3,45.5L54.7,23.4M4.6,43.6L4.6,58L53.8,58L53.8,43.6M29.2,45.1L29.2,0',
          onclick: () => {
            alert('myToolHandler1')
          }
        }
      }
    },
    xAxis: {
      boundaryGap: false,
      // data: Array(11).fill(0).map((item, index) => formart(startTime + day * index)),
      data: guttJson.date,
      //网格样式
      splitLine: {
        show: true,
        interval: 0,
        lineStyle: {
          color: ['#ccc'],
          width: 1,
          type: 'dashed'
        }
      },
      axisLabel: {
        align: 'center',
      }
    },
    yAxis: [{
      data: guttJson.yAxis,
      axisLabel: {
        lineHeight: 18,
        formatter: (value) => `{a|${value}}`,
        rich: {
          a: {
            width: 90,
            align: 'right'
          }
        }
      }
    }, {
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      data: constList
    }],
  
    grid: {
      top: 100,
      right: 100,
      // left: 175
      left: 240
    },
  
    visualMap: {
      // show:false,
      min: 0,
      // max: max,
      // max: max > 1000 ? null : max,
      ...maxObj,
      hoverLink: false,
      color: ['#fe5731', '#feebab'],
      calculable: false,
      orient: 'horizontal',
      bottom: 0,
      left: 'center',
      text: [max + ' 内容条数', 0]
    },
  
    series: [{
      type: 'custom',
      legendHoverLink: false,
      renderItem: renderItem,
      encode: {
        x: [1, 2],
        y: 0
      },
      silent:true,
      data: guttJson.list
    }]
  };

}   



// WEBPACK FOOTER //
// src/chart/gutt.js